<div>
  <ul>
    <li class="nav-item dropdown">
      <button
        type="button"
        class="btn btn-outline-product btn-block btn-sm dropdown-toggle d-flex justify-content-between align-items-center"
        data-toggle="dropdown"
      >
        <span style="font-size: 14px">{{
          productFieldLabel ? productFieldLabel : "Select Product"
        }}</span>
        <div class="w-100 d-flex justify-content-end">
          <strong
            ><span style="font-size: 14px" *ngIf="productCount > 0">Selected Item: {{ productCount }}</span></strong
          >
          <span class="caret"></span>
        </div>
      </button>
      <div
        class="dropdown-menu"
        style="max-height: 1000px; overflow-x: scroll; width: 100%"
      >
        <form>
          <label
            class="dropdown-item"
            *ngFor="let item of productlist; let i = index"
          >
            <input
              type="checkbox"
              style="font-size: 14px; text-transform: uppercase"
              (click)="toggleProduct($event, item)"
              [checked]="item.Checked"
            />{{ item.key }} - {{ item.price | currency }}
          </label>
        </form>
      </div>
    </li>
  </ul>
</div>

<div class="product-list">
  {{ productNames }}
</div>